import { z } from 'zod'
import { courtesyInformationSchema } from './courtesy-information'

export const programFeedbackSchema = z.object({
  /** 檻次順序 */
  thresholdSort: z.number(),
  /** 檻次金額 */
  amount: z.number(),
  /** 禮遇資訊 */
  courtesyInformation: courtesyInformationSchema,
  point: z.number(),
  pointMinRate: z.number().nullable(),
  pointMaxRate: z.number().nullable()
})

export interface ProgramFeedback
  extends z.infer<typeof programFeedbackSchema> {}
